import { message } from 'antd';
import ErrorIcon from '@/public/icons/error.svg'
import SuccessIcon from '@/public/icons/success.svg'

const messageService = {
  success: (data) => {
    message.success({
      icon: <SuccessIcon />,
      ...data,
    });
  },
  error: (data) => {
    message.error({
      icon: <ErrorIcon />,
      ...data
    });
  },
};

export default messageService;
